import { TableColumn } from '@iress-oss/ids-components';
import { GrowthRateTableDataRow } from '../../../types/GrowthRateTable';

export const growthRateTableColumns : TableColumn<GrowthRateTableDataRow>[] = [
    {
        key: 'growthRate',
        label: 'Growth rate',
        format: 'string',
        width: '30%',
    },
    {
        key: 'nominalRate',
        label: 'Nominal',
        format: 'string',
        align: 'right',
        width: '35%',
    },
    {
        key: 'inflationAdjustedRate',
        label: 'Inflation adjusted',
        format: 'string',
        align: 'right',
        width: '35%',
    },
];
